'use client';

import React from 'react';
import { useAuth } from 'react-oidc-context';

import { Mug, Setting } from '@zoomit/icons';
import { cn, Link } from '@zoomit/primitives';
import { Typography } from '@zoomit/zoomit-ds';

import { OriginURL } from '../../constants/apis';
import { onMyZoomitClick } from '../../helpers/events';
import { useWebKitCustomization } from '../../hooks/useWebKitCustomization';

type Props = React.ComponentProps<'div'>;

const getLinks = (userId: string, tenantTitle: string) => [
  {
    icon: Mug,
    title: `${tenantTitle} من`,
    href: 'profile/' + userId,
  },
  {
    icon: Mug,
    title: 'فعالیت‌ها',
    href: `profile/${userId}/activities/?tab=reads`,
  },
  {
    icon: Setting,
    title: 'تنظیمات',
    href: `profile/${userId}/settings/?form=userInfo`,
  },
];

const ProfileLinksMobile = (props: Props) => {
  const { className, ...rest } = props;
  const { user } = useAuth();
  const userId = user?.profile.sub;
  const tenantPersianTitle = useWebKitCustomization((config) => config.tenantPersianTitle);

  return (
    <div className={cn('flex justify-between gap-2', className)} {...rest}>
      {getLinks(userId!, tenantPersianTitle).map((item) => (
        <Link
          href={`${OriginURL}/${item.href}`}
          onClick={onMyZoomitClick}
          className="border-borderPrimary flex grow cursor-pointer flex-col items-center justify-center gap-2 rounded-sm border py-2"
          key={item.title}
        >
          <item.icon size="md" />
          <Typography className="leading-6">{item.title}</Typography>
        </Link>
      ))}
    </div>
  );
};

export default ProfileLinksMobile;
